import React, { createContext, useState } from 'react';
import { YMInitializer } from 'react-yandex-metrika';

import {
  Banner,
  Problems,
  Available,
  Access,
  Service,
  Feedback,
  Footer
} from '@/views';
import { Portal, Modal } from '@/components';

interface IContext {
  open: boolean;
  handleOpen: () => void;
  handleClose: () => void;
  condition: number;
  setCondition: React.Dispatch<React.SetStateAction<number>>;
}

export const PageContext = createContext<IContext>({
  open: false,
  handleOpen: () => null,
  handleClose: () => null,
  condition: 1,
  setCondition: () => null
});

const Page: React.FC = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [condition, setCondition] = useState<number>(1);

  const handleOpen = () => {
    setOpen(true);
    document.body.classList.add('body-hidden');
  };

  const handleClose = () => {
    setOpen(false);
    document.body.classList.remove('body-hidden');
  };

  return (
    <PageContext.Provider
      value={{
        open,
        handleOpen,
        handleClose,
        condition,
        setCondition
      }}
    >
      <YMInitializer accounts={[97557024]} />
      <Banner />
      <Problems />
      <Available />
      <Access />
      <Service />
      <Feedback />
      <Footer />
      <Portal>
        <Modal open={open} onClose={handleClose} />
      </Portal>
    </PageContext.Provider>
  );
};

export default Page;
